<template>
  <v-form v-model="formValid">
    <v-layout wrap align-start justify-center>

      <v-flex xs12 px-1>
        <v-text-field
            label="Nombre"
            placeholder="Ej. Casa Central"
            outlined
            clearable
            v-model="branchOfficeName"
            hint="el nombre será solo utilizado como referencia para ti"
            persistent-hint
            prepend-inner-icon="far fa-building"
            />
      </v-flex>

      <v-flex xs12 class="mt-2" px-1>
        <location-picker
            v-if="showLocationPicker"
            @blur="startValidation = true"
            @change="branchOfficeAddress = $event"
            :outline="true"
            :hide-details="false"
            :text-limit="100"
            :default-value="defaultAddress"
            placeholder=""
            prepend-icon="fa-map"
            :error-messages="locationErrors"
        />
      </v-flex>

      <v-flex xs12 md6 px-1>
        <v-text-field
            label="Detalles (opcional)"
            outlined
            clearable
            prepend-inner-icon="fa-street-view"
            v-model="branchOfficeAddress2"
            placeholder="Ej. Oficina 25, piso 7, etc."
        />
      </v-flex>

      <v-flex xs12 md6 px-1>
        <v-text-field
            label="Teléfono"
            outlined
            v-model="branchOfficePhone"
            :rules="phoneRules"
            prefix="(+56)"
            mask="# #### ####" />
      </v-flex>

    </v-layout>
  </v-form>
</template>

<script>
import LocationPicker from "../../../components/common/LocationPicker";
export default {
  name: "BranchOfficeForm",
  components: {LocationPicker},
  props:{
    strictMode: {
      type: Boolean,
      default: false
    },
    default: {
      type: Object
    }
  },
  mounted(){
    const vm = this
    vm.setDefaults()
    setTimeout(function(){
      vm.showLocationPicker = true
    }, 100)
  },
  data(){
    return {
      showLocationPicker: false,
      formValid: false,
      startValidation: false,
      branchOfficeName: '',
      nameRules: [
          v => !!v && v.length > 3 || 'requiere al menos 3 caracteres'
      ],
      branchOfficeAddress: null,
      branchOfficeAddress2: '',
      branchOfficePhone: '',
      phoneRules: [
        v => /[1-9]\s?[0-9]{4}\s?[0-9]{3,4}/.test(v) || 'Teléfono inválido'
      ],
    }
  },
  computed:{
    office(){
      const vm = this
      return {
        name: vm.branchOfficeName,
        phone1: vm.branchOfficePhone,
        address: vm.branchOfficeAddress && vm.branchOfficeAddress.address && vm.branchOfficeAddress.address.full || '',
        address_2: vm.branchOfficeAddress2,
        latitude: vm.branchOfficeAddress && vm.branchOfficeAddress.location && vm.branchOfficeAddress.location.lng || '',
        longitude: vm.branchOfficeAddress && vm.branchOfficeAddress.location && vm.branchOfficeAddress.location.lat || ''
      }
    },
    defaultAddress(){
      const vm = this

      if(!vm.default || !vm.default.address) return null
      return JSON.parse(JSON.stringify({
        text: vm.default.address || '',
        location: !!vm.default.longitude && !!vm.default.longitude ? {
          lng: vm.default.longitude,
          lat: vm.default.latitude
        } : null
      }))

    },
    locationErrors(){

      const vm = this
      const message = 'Dirección incorrecta'

      if(!vm.startValidation) return ''

      if(vm.strictMode){
        if(
            !vm.office.address
            || !vm.office.latitude
            || !vm.office.longitude
        ){
          return message
        }
      }

      if(!vm.office.address){
        return message
      }

      return ''

    },
    valid(){
      const vm = this

      if(vm.strictMode){
        return Boolean(
            vm.office.name
            && vm.office.address
            && vm.office.latitude
            && vm.office.longitude
            && vm.office.phone1
            && vm.formValid
        )
      }

      return Boolean(
          vm.office.name
          && vm.office.address
          && vm.office.phone1
          && vm.formValid
      )

    }
  },
  methods:{
    reset(){
      const vm = this
      vm.branchOfficeName = ''
      vm.phone1 = ''
      vm.address = ''
      vm.address_2 = ''
      vm.latitude = ''
      vm.longitude = ''
    },
    setDefaults(){
      const vm = this
      vm.default && console.log('setting default branch office: ', JSON.parse(JSON.stringify(vm.default)))
      vm.branchOfficeName = vm.default && vm.default.name || ''
      vm.branchOfficeAddress = (vm.default && vm.default.address) ? {
        address: vm.default.address,
        longitude: vm.default.longitude,
        latitude: vm.default.latitude
      } : null
      vm.branchOfficeAddress2 = vm.default && vm.default.address_2 || ''
      vm.branchOfficePhone = vm.default && vm.default.phone1 || ''
    }
  },
  watch:{
    branchOfficeAddress(){
      const vm = this
      vm.startValidation = true
    },
    office(val){
      const vm = this
      vm.$emit('change', val)
    },
    valid(val){
      const vm = this
      vm.$emit('change:validation', val)
    },
    default(val){
      const vm = this
      vm.setDefaults()
    }
  }
}
</script>

<style scoped>

</style>
